<template>
  <div>
    <h1 class="text-center text-xl md:text-4xl text-gray-700 pt-5">資金管理ツール（{{activeName}}）</h1>

    <el-radio-group v-model="activeName" class="ml-3">
      <el-radio-button label="株版"></el-radio-button>
      <el-radio-button label="FX版"></el-radio-button>
    </el-radio-group>

    <funds-management-fx v-if="activeName === 'FX版'"></funds-management-fx>
    <funds-management-kabu v-if="activeName === '株版'"></funds-management-kabu>
  </div>
</template>

<script>
import FundsManagementFx from '@/components/tools/FundsManagementFx'
import FundsManagementKabu from '@/components/tools/FundsManagementKabu'

export default {
  data() {
    return {
      activeName: '株版'
    }
  },
  components: {
    FundsManagementFx,
    FundsManagementKabu
  }
}
</script>